const choices = {
    yesFond: 'Oui avec des fonds en euros',
    yesMixte: 'Oui avec un mixte de fonds en euros et unité de comptes',
    yesCompte: 'Oui avec uniquement des unités de compte',
    no: 'Non',
};

export default choices;
